import { useQuery } from "@tanstack/react-query"

import { getLocations } from "@/api/getLocations.ts"

export default function RenderLocation({ id }: { id: number }) {
  const { data, isPending, isError } = useQuery({
    queryKey: ["locations"],
    queryFn: () => getLocations(),
  })

  if (isPending) return <>Loading...</>
  if (isError) return <>Network Error</>
  const location = data.find((l) => l.id == id)
  return <>{location?.name || "N/A"}</>
}
